// src/features/rooms/SelectedRoomsValidationsModal.tsx
import React from "react";
import { Modal, Group, Text, ActionIcon, Tooltip, Divider } from "@mantine/core";
import { FaTimes } from "react-icons/fa";
import { useAppSelector } from "../../../app/hooks";
import { SelectedRoomsValidationsAgGrid } from "./SelectedRoomsValidationsAgGrid";
import { selectSpaceValidationsMatrixForSelectedRoomsExcludingStandardRoom } from "./selectedRoomDevicesSelectors"; // ⚠️ juster path

type Props = {
  opened: boolean;
  onClose: () => void;
};

export const SelectedRoomsValidationsModal: React.FC<Props> = ({ opened, onClose }) => {
  const matrix = useAppSelector(selectSpaceValidationsMatrixForSelectedRoomsExcludingStandardRoom);

  const title =
    matrix.selectedRoomsCount === 0
      ? "Regler – valgte rom"
      : `Regler – valgte rom (${matrix.selectedRoomsCount})`;

  return (
    <Modal
      size="90rem"
      opened={opened}
      onClose={onClose}
      centered
      title={
        <Group justify="space-between" align="center" w="100%" wrap="nowrap">
          <Text fw={700}>{title}</Text>
          <Tooltip label="Lukk" withArrow>
            <ActionIcon variant="subtle" color="gray" onClick={onClose} aria-label="Lukk">
              <FaTimes size={14} />
            </ActionIcon>
          </Tooltip>
        </Group>
      }
    >
      <Group justify="space-between" align="center" mb="xs">
        <Text size="sm" c="dimmed">
          Godkjent: {matrix.approvedRoomsCount} • Ikke godkjent: {matrix.notApprovedRoomsCount} •
          Rom uten enheter: {matrix.roomsWithoutDevicesCount}
        </Text>
      </Group>

      <Divider mb="sm" />

      {/* Big content area */}
      <SelectedRoomsValidationsAgGrid />
    </Modal>
  );
};
